import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import API from '../../../modules/common/services/api.config.json';
import { ApiService } from 'app/modules/common/services/api.service';

@Injectable()

export class CalanderFullService {

  public selectedNode: any;
  public isCalendarLoading = false;

  constructor(
    private apiService: ApiService) { }

  getCalendarForNextTwoMonths(_selectedNode = null): Observable<any> {
    if (_selectedNode != null) { this.selectedNode = _selectedNode; }
    const url = `${API.Calendar.getCalendarForNextTwoMonths}`;
    return this.apiService.post(url, this.selectedNode);
  }

  saveRemoveAppointment(data): Observable<any> {
    const url = `${API.Calendar.saveAppointment}`;
    return this.apiService.post(url, data);
  }

  downloadCalendar(datosExcelReserva): Observable<any> {
    var url = `${API.Calendar.downloadCalendar}`;
    return this.apiService.post(url, datosExcelReserva);
  }

    downloadCalendarMultiple(datosExcelReservaMultiple): Observable<any> {
    var url = `${API.Calendar.downloadCalendarMultiple}`;
    return this.apiService.post(url, datosExcelReservaMultiple);
  }

}
